import { useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Layout from "./Layout";

function CategoryShouldCost({ username, onSignOut }) {
    const location = useLocation();
    const navigate = useNavigate();

    // Pull from state or localStorage
    const { title: stateTitle, description } = location.state || {};
    const [title, setTitle] = useState(stateTitle || localStorage.getItem("categoryTitle"));

    useEffect(() => {
        if (stateTitle) {
            localStorage.setItem("categoryTitle", stateTitle);
        }
    }, [stateTitle]);

    const handleClick = (query) => {
        navigate("/ShouldChatbot", {
            state: {
                query: `${query} for category ${title}`,
                category: title,
            },
        });
    };

    return (
        <Layout username={username} onSignOut={onSignOut}>
            <div className="container-fluid Home">
                <div className="row">
                    <div className="SummaryBreadCrumb border-b-[1px] border-[#CFCFCF] gap-2">
                        <Link to="/">
                            <span className="SummaryBreadCrumbInside cursor-pointer hover:text-black">
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
                                    <path d="M8.33464 17.4538V12.4538H11.668V17.4538H15.8346V10.7871H18.3346L10.0013 3.28711L1.66797 10.7871H4.16797V17.4538H8.33464Z" />
                                </svg>
                                <span className="SummaryText">Home</span>
                            </span>
                        </Link>
                        <span>/</span>
                        <Link to="/LandingPage">
                            <span className="SummaryBreadCrumbInside hover:text-black cursor-pointer">Should Cost Modeling</span>
                        </Link>
                        <span>/</span>
                        <span className="HomeText">{title}</span>
                    </div>
                </div>
                <div className="row">
                    <div className="col-1"></div>
                    <div className="col-10 flex justify-center">
                        <div className="pt-10 pb-3 text-[#000000] font-semibold text-[14px]">
                            <span>Please select an option to proceed</span>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-1"></div>
                    <div className="col-10 justify-center gap-2 flex-wrap flex items-center">
                        <div
                            className="LandingSearchBar-types w-1/4 cursor-pointer hover:bg-[#e4d4ff]"
                            onClick={() => handleClick("Create should cost for one part")}
                        >
                            <span className="LandingSearchBar-typesHeading">Create should cost for one part</span>
                            <span className="subcatrgory">A guided, step by step approach for should costing for one part at a time</span>
                        </div>
                        <div
                            className="LandingSearchBar-types w-1/4 cursor-pointer hover:bg-[#e4d4ff]"
                            onClick={() => handleClick("Create should cost for multiple parts")}
                        >
                            <span className="LandingSearchBar-typesHeading">Create should cost for multiple parts</span>
                            <span className="subcatrgory">Run batch should-costing for multiple parts simultaneously.</span>
                        </div>
                    </div>
                </div>
            </div>
        </Layout>
    );
}

export default CategoryShouldCost;
